import axios from "axios";

export default {
    async index(params) {
        return (await axios.get("/api/admin/modulos/pagos", { params })).data;
    },

    /**
     * Opciones disponibles para los filtros, acotadas por los filtros ya aplicados.
     * Cada listado ignora su propio filtro, para poder cambiar la selección actual.
     */
    async getOpcionesFiltros(params) {
        const { data } = (
            await axios.get("/api/admin/modulos/pagos/opciones-filtros", { params })
        ).data;

        return {
            proveedores: data?.proveedores ?? [],
            tiposDocumentoContable: data?.tipos_documento_contable ?? [],
        };
    },

    async downloadPago(id) {
        window.open(
            process.env.VUE_APP_API_URL +
            `/api/admin/archivo/${id}/descargar/despacho`
        );
    },
};